import WrapVacancies from './WrapVacancies';
export default WrapVacancies;